import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Terms } from "./pages/Terms/Terms.page";
import { Landing } from "./pages/Landing/Landing.page";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy-policy" element={<Terms />} />
        <Route path="/*" element={<Landing />} />
      </Routes>
    </Router>
  );
}

export default App;
